import { FilterField, SkinAppearancesFieldInterface } from './Types';

export function filterSkinAppearanceFields(
    ageGroupFields: FilterField[],
    currentSkinAppearanceFields: SkinAppearancesFieldInterface[],
): SkinAppearancesFieldInterface[] {
    const activeAgeGroupField = ageGroupFields.find((field) => field.checked);

    // clear disabled states from current fields
    let filteredFields = currentSkinAppearanceFields.map((field) => {
        const newSkinApperanceField = { ...field, disabled: false };
        return newSkinApperanceField;
    });

    // filter by active age group
    if (activeAgeGroupField) {
        filteredFields = filteredFields.map((skinAppearanceField) => {
            const newSkinApperanceField = { ...skinAppearanceField };
            if (!skinAppearanceField.supportedAgeGroups.includes(activeAgeGroupField.filterValue)) {
                newSkinApperanceField.disabled = true;
                newSkinApperanceField.checked = false;
            }
            return newSkinApperanceField;
        });
    }

    return filteredFields;
}

export function filterAgeGroupFields(
    skinAppearancesFields: SkinAppearancesFieldInterface[],
    currentAgeGroups: FilterField[],
): FilterField[] {
    const checkedSkinAppearance = skinAppearancesFields.find(
        (skinAppearancesField) => skinAppearancesField.checked === true,
    );
    return currentAgeGroups.map((ageGroupField) => {
        const newAgeGroupField = { ...ageGroupField, disabled: false };

        // check if agegroup is allowed in combination with currently selected skin appereance
        if (checkedSkinAppearance && !checkedSkinAppearance.supportedAgeGroups.includes(newAgeGroupField.filterValue)) {
            newAgeGroupField.disabled = true;
            newAgeGroupField.checked = false;
        }

        return newAgeGroupField;
    });
}
